@use "../../../styles/Colors.scss" as Colors;
@use "../../../styles/Constants.scss" as Constants;

.pdfView {
	display: block;
}

.pdfView__state {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: Constants.$val-spacing-s;
	padding: Constants.$val-spacing-m;
	color: Colors.$col-greyDark;
}

.pdfView__spinner {
	position: relative;

	&::after {
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		border: Constants.$val-borderSize-s solid transparent;
		border-radius: 50%;
		animation: pdfViewSpin 1s ease infinite;
		border-top-color: Colors.$col-greyDark;
		border-right-color: Colors.$col-greyDark;
		border-bottom-color: Colors.$col-greyDark;
		height: Constants.$val-icon14; width: Constants.$val-icon14;
	}
}

@keyframes pdfViewSpin {
	from {
		transform: rotate(0turn);
	}

	to {
		transform: rotate(1turn);
	}
}

.companyCompliance {
	:global(.notion-header) {
		position: static;
		z-index: unset;

		:global(.notion-nav-header) {
			position: static;
		}
	}

	:global(.notion-asset-wrapper) {
		max-width: 100%;
	}
}
